import * as React from 'react';
import {
  ArticlePageLeftMenuContainer,
  LeftMenuNews,
  NewsBonds,
  NewsSidebarNewsLetter,
} from './components';

export const ArticlePageLeftMenu = () => (
  <ArticlePageLeftMenuContainer>
    <NewsBonds />
    <NewsSidebarNewsLetter />
    <LeftMenuNews />
  </ArticlePageLeftMenuContainer>
);
